import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  propertyDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    height: '100%',
    gap: '16px',
  },
  title: {
    color: '#4D5365',
    fontFamily: 'Noto Sans',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '36px',
    marginBottom: '16px',
  },
  dataCard: {
    marginBottom: '16px',
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    overflow: 'visible',
  },
  dataGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    padding: '16px',
  },
  dataItem: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    alignItems: 'center',
  },
  dataLabel: {
    color: '#4D5365',
    fontFamily: 'Noto Sans',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
  },
  dataValue: {
    color: '#6B7280',
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    textTransform: 'capitalize',
    width: '100%',
  },
  errorMessage: {
    color: '#DC2626',
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'center',
    padding: '24px',
  },
  backButton: {
    marginTop: 'auto',
    alignSelf: 'flex-start',
  },
  structureTitle: {
    color: '#4D5365',
    fontFamily: 'Noto Sans',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    marginBottom: '16px',
  },
}));
